import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get, flow, keyBy, filter } from 'lodash/fp';
import loading from '../../actions/loading';
import loaded from '../../actions/loaded';
import globalError from '../../actions/globalError';
import editMandiAttributes from '../../actions/editMandiAttributes';

import MandiEditAttributesModal from './MandiEditAttributesModal';

const mapStateToProps = ({ estimateBuilder }, { designId }) => {
  const items = flow(
    get('entities.items.byId'),
    filter({ designId }),
    keyBy('itemId'),
  )(estimateBuilder);

  return {
    items,
  };
};

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ editMandiAttributes }, dispatch),
  setLoading: value => (value
    ? dispatch(loading())
    : dispatch(loaded())
  ),
  globalError: err => dispatch(globalError({ err })),
});

export default connect(mapStateToProps, mapDispatchToProps)(MandiEditAttributesModal);
